import { useRef } from 'react';
import { useLoader } from '@react-three/fiber';
import { useVideoTexture } from '@react-three/drei';
import * as THREE from 'three'

// Components
import CylinderImage from './CylinderImage'

// Constant values
const count = 5
const thetaLength = (2 * Math.PI) / count
const offset = thetaLength

const geometry = new THREE.CylinderGeometry(2, 2, 1.4, 36, 36, true, 0, thetaLength)

const Cylinder = ({enableControls}) =>
{
    // Ref for group
    const groupRef = useRef()

    // Textures
    const textures = [
        useVideoTexture('./images/1.mp4', { minFilter: THREE.NearestFilter, magFilter: THREE.NearestFilter, format: THREE.RGBFormat}),
        useVideoTexture('./images/2.mp4', { minFilter: THREE.NearestFilter, magFilter: THREE.NearestFilter, format: THREE.RGBFormat}),
        useVideoTexture('./images/3.mp4', { minFilter: THREE.NearestFilter, magFilter: THREE.NearestFilter, format: THREE.RGBFormat}),
        useVideoTexture('./images/4.mp4', { minFilter: THREE.NearestFilter, magFilter: THREE.NearestFilter, format: THREE.RGBFormat}),
        useVideoTexture('./images/5.mp4', { minFilter: THREE.NearestFilter, magFilter: THREE.NearestFilter, format: THREE.RGBFormat}),
    ]

    return(
        <group position={[0, 0.35, 0]} ref={groupRef}>
            <CylinderImage texture={textures[0]} rotation={[0, offset * 0, 0]} id="retail" geometry={geometry} enableControls={enableControls} delay={0} />
            <CylinderImage texture={textures[1]} rotation={[0, offset * 1, 0]} id="owners" geometry={geometry} enableControls={enableControls} delay={0.15} />
            <CylinderImage texture={textures[2]} rotation={[0, offset * 2, 0]} id="anila" geometry={geometry} enableControls={enableControls} delay={0.3} />
            <CylinderImage texture={textures[3]} rotation={[0, offset * 3, 0]} id="map" geometry={geometry} enableControls={enableControls} delay={0.45} />
            <CylinderImage texture={textures[4]} rotation={[0, offset * 4, 0]} id="3d-customizer" geometry={geometry} enableControls={enableControls} delay={0.6} />
        </group>
    )
}

export default Cylinder